import { render, staticRenderFns } from "./PieNew.vue?vue&type=template&id=3e122046&scoped=true&"
import script from "./PieNew.vue?vue&type=script&lang=js&"
export * from "./PieNew.vue?vue&type=script&lang=js&"
import style0 from "./PieNew.vue?vue&type=style&index=0&id=3e122046&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e122046",
  null
  
)

export default component.exports